import { $themeBreakpoints } from "@themeConfig";
import region from "@/config/regions";

// Public storage roots, derived from the region resolved at runtime.
const storage = `${region.storageUrl}/`;

export default {
  namespaced: true,

  state: {
    baseURL: `${storage}images/`,
    profileURL: `${storage}profile/`,
    fileURL: `${storage}files/`,
    excelFileURL: `${storage}excel_files/`,
    settingURL: `${storage}settings/`,
    leadFileURL: `${storage}Leads/`,
    portfolioFileURL: `${storage}portfolio/`,
    companiesURL: `${storage}company/`,

    windowWidth: 0,
    shallShowOverlay: false,
    token: "",
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state;
      if (windowWidth >= $themeBreakpoints.xl) return "xl";
      if (windowWidth >= $themeBreakpoints.lg) return "lg";
      if (windowWidth >= $themeBreakpoints.md) return "md";
      if (windowWidth >= $themeBreakpoints.sm) return "sm";
      return "xs";
    },

    isAuthenticated(state) {
      return state.token !== "";
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay =
        val !== undefined ? val : !state.shallShowOverlay;
    },
  },
  actions: {},
};
